import type { Feature } from 'geojson';
import { ClosedRoadLayer } from '../Layers/ClosedRoadLayer';
import type { ClosedRoadLayerOptions } from '../Layers/Layers.types';

export const closedRoad = function (feature: Feature, options?: Partial<ClosedRoadLayerOptions>): ClosedRoadLayer {
    return new ClosedRoadLayer({ feature, ...options } as ClosedRoadLayerOptions);
};
